import React from 'react';
import PropTypes from 'prop-types';
import FilePreviewerAndTagger from './FilePreviewerAndTagger';
import { XIcon } from '@forwardfinancing/component-library';
import colors from '../../../constants/colors';
import linkUtils from '../../../lib/linkUtils';
import { trackUserInput } from '@forwardfinancing/analytics-frontend-library';
import { filesMissingMetadata } from '../../../lib/stipFileValidation';

export class StipsPreviewerAndTaggerTool extends React.Component {
  handleCloseAndTrack() {
    this.props.onClose();
    const page = linkUtils.getLocationName(window);
    this.props.files.map(file =>
      trackUserInput({
        label: "Document types",
        document_type: file.tag,
        page: page
      })
    );
  }

  renderXButton() {
    return(
      <a
        onClick={this.handleCloseAndTrack.bind(this)}
        type="button"
      >
        <XIcon
          fill={colors.gray3}
          width="30"
          strokeWidth="2"
        />
      </a>
    );
  }

  renderFilePreviewer() {
    return (
      this.props.files.map((file, idx) =>
        <FilePreviewerAndTagger
          file={file}
          handleSetTag={this.props.handleSetTag}
          handleSetDescription={this.props.handleSetDescription}
          handleSetOwner={this.props.handleSetOwner}
          handleSetExpiration={this.props.handleSetExpiration}
          owners={this.props.owners}
          key={idx}
          fileTaggerDropdownOptions={this.props.fileTaggerDropdownOptions}
        />)
      );
  }

  // Underwriting rejects an "Other"-tagged stip without a description, and a
  // Drivers License without an expiration date or an owner, so block "Done"
  // until every file carries what its tag requires.
  missingRequiredMetadata() {
    const ownerCount = (this.props.owners || []).length;
    return filesMissingMetadata(this.props.files, ownerCount).length > 0;
  }

  renderButton() {
    const disabled = this.missingRequiredMetadata();
    return(
      <div className="file-previewer-container__footer">
        {disabled &&
          <p className="file-previewer-container__validation">
            Please complete the required details for each document. Documents tagged
            "Other" need a description; a Drivers License needs an expiration date,
            and an owner when the business has more than one.
          </p>
        }
        <button
          onClick={this.handleCloseAndTrack.bind(this)}
          className="stips-previewer-close button is-primary"
          type="button"
          disabled={disabled}
        >
          Done
        </button>
      </div>
    );
  }

  render() {
    const isActive = this.props.isActive;
    return (
      <div className={`stips-previewer-modal modal-component modal ${isActive ? 'is-active' : ''}`}>
        <div className="modal-component__background modal-background" />
        <div className="modal-component__content modal-card">
          <div className="modal-component__content-body modal-card-body file-previewer-modal">
            <div className="modal-component__content-lines-wrap file-previewer-container">
              <div className="file-previewer-container__header">
                <div className="file-previewer-container__x-button">
                  {this.renderXButton()}
                </div>
                <div className="file-previewer-container__title">
                  <h3>Document Previewer</h3>
                </div>
              </div>
              <div className="file-previewer-container__body">
                <div className="file-previewer-container__previewer">
                  {this.renderFilePreviewer()}
                </div>

              </div>
              {this.renderButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StipsPreviewerAndTaggerTool.propTypes = {
  isActive: PropTypes.bool,
  files: PropTypes.array,
  onClose: PropTypes.func,
  handleSetTag: PropTypes.func,
  handleSetDescription: PropTypes.func,
  handleSetOwner: PropTypes.func,
  handleSetExpiration: PropTypes.func,
  fileTaggerDropdownOptions: PropTypes.array,
  owners: PropTypes.array
};

export default StipsPreviewerAndTaggerTool;
